export default "__VITE_ASSET__12f57682__"